import styled, { keyframes } from 'styled-components';
import Watchlist from '@assets/images/watchlist/watchlist-symbol.svg';
import { media } from '@simplywallst/ui-core';

const reveal = keyframes`
	from 				{opacity: 0;}
	to 					{opacity: 1;}
`;

const flash = keyframes`
	0% 				    {opacity: 0.2;}
	70% 				  {opacity: 0.2;}
	72% 					{opacity: 1;}
	98% 					{opacity: 1;}
	100% 					{opacity: 0.2;}
`;

const pop = keyframes`
	0% 				    {transform: scale(0);}
	70% 				  {transform: scale(0);}
	72% 					{transform: scale(1);}
	98% 					{transform: scale(1);}
	100% 					{transform: scale(0);}
`;

export const WatchlistSVG = styled(Watchlist)`
  display: block;
  margin: ${({ theme }) => theme.x10spacePx}px auto 0;
  ${media.mdDown`
    margin-top: ${({ theme }) => theme.x5spacePx}px;
  `}
  opacity: 0;
  animation: ${reveal} 0.3s linear forwards;
  > rect[fill='#2DC97E'] {
    animation: 3s ease-in infinite forwards ${flash};
  }
  > rect[fill='#E64141'] {
    animation: 2s ease-in infinite forwards ${flash};
  }
  > rect[fill='#2C85FD'] {
    transform-origin: 10px 10px;
    animation: 5s ease-in infinite forwards ${pop};
  }
  > rect[fill='#2C85FD'][x='76'] {
    transform-origin: 80px 39px;
    animation: 6s ease-in 1s infinite forwards ${pop};
  }
  > rect[fill='#2C85FD'][x='6'][y='35'] {
    transform-origin: 10px 39px;
    animation: 5s ease-in 0.5s infinite forwards ${pop};
  }
  > rect[fill='#2C85FD'][x='76'][y='6'] {
    transform-origin: 80px 10px;
    animation: 4s ease-in 2.5s infinite forwards ${pop};
  }
`;
